import React from 'react';
import Moved from './pages/Moved';

function App(): JSX.Element {
  return <Moved />;
}

export default App;
